import { render } from "./AboutMedicare.vue?vue&type=template&id=ae7df952"
import script from "./AboutMedicare.vue?vue&type=script&lang=js"
export * from "./AboutMedicare.vue?vue&type=script&lang=js"

import "./AboutMedicare.vue?vue&type=style&index=0&id=ae7df952&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__